import { WithTheme } from '@issuemanager/apps/client/theme';
import {
  ClickAwayListener,
  ClickAwayListenerProps,
  Popper,
  PopperProps,
  styled,
} from '@mui/material';
import React from 'react';

type Props = {
  onClose: ClickAwayListenerProps['onClickAway'];
} & React.PropsWithChildren &
  PopperProps;

const StyledPopper = styled(Popper)<WithTheme<PopperProps>>(({ theme }) => ({
  width: 'fit-content',
  height: 'fit-content',
  zIndex: theme.zIndex.modal,
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.tokens.core.shadow.low.value.stringValue,
}));

export function FilterPopper(props: Props) {
  const { onClose, children, ...rest } = props;
  return (
    <StyledPopper {...rest}>
      <ClickAwayListener
        onClickAway={onClose}
        mouseEvent='onMouseDown'
        touchEvent='onTouchStart'
      >
        <div>{children}</div>
      </ClickAwayListener>
    </StyledPopper>
  );
}
